import { BankAccountType } from '../../lib/typegen/bank-account-type';

/**
 * ConEd's GetAccountInfo returns LastBankAccountType as the single-letter codes
 * "C" / "S"; other CIS integrations (and AccountStore's own fallback) use the
 * long-form names. Anything unrecognised is treated as Checking, matching the
 * pre-existing default.
 */
export const resolveSavedBankAccountType = (savedACHLastAccountType: string | null | undefined): BankAccountType => {
	const normalized = (savedACHLastAccountType ?? '').trim().toLowerCase();
	return normalized === 's' || normalized === 'savings' ? BankAccountType.Savings : BankAccountType.Checking;
};

/**
 * ConEd returns only the last four digits of the saved bank account and never
 * its true length, so the mask is a fixed four-asterisk prefix rather than a
 * length-derived one. maskValue()/Strings.ObscureNumber both return a
 * 4-character input unchanged, which is why neither can be reused here.
 */
export const SAVED_ACCOUNT_MASK_PREFIX = '****';

export const formatSavedAccountNumber = (savedACHLastFour: string | null | undefined): string => {
	const lastFour = (savedACHLastFour ?? '').trim();
	if (!lastFour) return '';
	return `${SAVED_ACCOUNT_MASK_PREFIX}${lastFour}`;
};
